import React,{useEffect} from 'react';
import Form from './Form';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { useNavigate,useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useEntityCrud } from '../../hooks/useEntityCrud';

const Create = () => {

    const { id } = useParams();
    const {readData} = useEntityCrud('Role/GetRole?RoleId=' + id);
    const {addData: updateData} = useEntityCrud('Role/UpdateRole');
    const navigate = useNavigate();

    const initialValues = {
        title: '',
        businessEnable: 0
    };

    useEffect(() => {
        readData().then(({data}) => {
            if(data.status)
                formik.setValues({
                    ...data.result,
                    businessEnable: data.result.businessEnable ? 1 : 0
                });
        });
    },[]);
    
    const validationSchema = Yup.object({
        title: Yup.string()
        .required(),
        businessEnable: Yup.string()
        .required()
    });
    
    const onSubmit = (values) => {
        document.getElementById('btn-submit-form').classList.add('btn-loading');
        const postedData = {
            id,
            title: values.title,
            businessEnable: values.businessEnable == 1
        };
        updateData(postedData).then(({data}) => {
            if(data.status){
                toast.success('به روزرسانی نقش با موفقیت انجام شد');
                return navigate('/roles');
            }else
                data.errors.map(error => toast.error(error.message));
        }).finally(() => document.getElementById('btn-submit-form').classList.remove('btn-loading'));
    }

    const formik = useFormik({
        initialValues: initialValues,
        onSubmit,
        validationSchema: validationSchema
    });

    const handleBack = () => {
        navigate('/roles',{replace: true});
    }

    return (
        <div className="card">
            <div className="card-header d-flex justify-content-between">
                <div className="card-title">ویرایش نقش</div>
                <a className="backIconLink" onClick={handleBack}><i className="fa fa-arrow-left" title="بازگشت"></i></a>
            </div>
            <div className="card-body">
                <Form formik={formik} />
            </div>
        </div>
    );
}

export default Create;